module.exports = __webpack_public_path__ + "img/业务编码.6457ce61.svg";